// extracted by css-extract-rspack-plugin
module.exports =  {"swicthTabWrap":"R_YIB","tab":"uU_Dt","active":"KdrG0","large":"TbVOB","partyInfoWrap":"JGzX1"};